// window.Helper = {
'use strict'

import Vue from 'vue'

Vue.mixin({
	data () {
	},
	components: {
	},
	computed: {
	},
	methods: {
	
		alertSuccessMessage (response, id = '') {
			const redirectUrl = _.get(response, 'data.redirect_url')

			if(redirectUrl) {
				window.location.href = redirectUrl
				return
			}

			var $form = $(`${id}`)
			$form.find('[role="alert"]').remove()
		
			let message = _.get(response, 'data.message')
			let style = 'success'
			let icon = 'far fa-check-circle'

			if(message) {
				$form.prepend(`
					<div class="alert alert-${style}" role="alert">
						<i class="icon ${icon} text-${style}"></i>
						<p class="message">${this.$t(message)}</p>
					</div>
				`)
			}
		},

		alertErrorMessage (error, id) {
			const response = _.get(error, 'response')
			const status = _.get(response, 'status')
			const redirectUrl = _.get(response, 'data.redirect_url')

			if(redirectUrl) {
				window.location.href = redirectUrl
				return
			}

			var $form = $(`${id}`)
			$form.find('[role="alert"]').remove()
		
			let message = _.get(response, 'data.message')
			let style, icon

			switch(status) {
				case 401:
					window.location = '/logout'
					break

				case 500:
				case 501:
				case 502:
				case 503:
				case 504:
				case 505:
					message = 'มีบางอย่างผิดพลาด โปรดรอสักครู่และดำเนินการอีกครั้ง'
					style = 'danger'
					icon = 'far fa-exclamation-circle'
					break

				default:
					style = 'warning'
					icon = 'far fa-exclamation-circle'
			}

			if(message) {
				$form.prepend(`
					<div class="alert alert-${style}" role="alert">
						<i class="icon ${icon} text-${style}"></i>
						<p class="message">${this.$t(message)}</p>
					</div>
				`)
			}
		},
		
		inputOnlyNumber (e) {
			e = (e) ? e : window.event
			var charCode = (e.which) ? e.which : e.keyCode
			if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
				e.preventDefault()
			} else {
				return true
			}
		},
	}
})